// extracted by mini-css-extract-plugin
export default {"wrapper":"CallToActionScreen_wrapper__UFGrL"};